import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import ReactTable from "react-table";
import Select from 'react-select';
import { Restrict } from '../components/Restrict';
import { peTaskColumns } from '../config/column_fields';
import Modal from 'react-responsive-modal';
// import {  } from '../actions/fetchPeTasks';
import { createNewTask, fetchPeTask, updateTask, deleteTask, addNewComment, fetchTaskComments, fetchPeMapping, markTaskComplete, fetchLoggedInUserName, fetchQuoteId, searchSites, resetAutoAssign, autoAssignTasks } from '../actions/peTaskV2Actions';
import moment from 'moment';
import debounce from 'lodash/debounce'
import { Link } from 'react-router-dom';
import { fetchmainview } from '../actions/fetchmainview';

const teamOptions = [
    { label: 'PE', value: 'PE' },
    { label: 'PM', value: 'PM' }
];

const statusOptions = [
    { label: 'Pending', value: '0' },
    { label: 'Completed', value: '1' }
];

const preferredStates = ['Uttar Pradesh', 'Delhi', 'Maharashtra', 'Odisha'];

class PeTaskV2 extends Component {


    constructor(props) {
        super(props);
        this.state = {
            showColumns: peTaskColumns,
            allData: [],
            viewData: [],
            openUpdateModal: false,
            openCreateModal: false,
            openAutoAssignModal: false,
            quoteList: [],
            peMapping: {},
            employeeList: {},
            newTask: {
                date: '',
                quoteId: '',
                state: '',
                type: '',
                employee: '',
                comment: '',
                pmComment: '',
                priority: '',
                size_del: '',
                team: ''
            },
            updateTask: {
                date: '',
                quoteId: '',
                state: '',
                type: '',
                employee: '',
                comment: '',
                pmComment: '',
                id: '',
                priority: '',
                status: '',
                statusVal: '',
                team: ''
            },
            filters: {
                startDate: '',
                endDate: '',
                state: '',
                employee: '',
                team: '',
                status: '0'
            },
            appliedFilters: {},
            loading: true,
            editButton: true,
            selectView: { "ALL": 1 },
            searchBy: { label: "Quote Id", value: "quoteId" },
            fetchQuoteIdError: false,
            cityList: [],
            autoAssignData: {
                city: '',
                date: ''
            },
            newCommentText: '',
            commentForTaskId: '',
            taskComments: [],
            quoteToStageMap: {}
        };

        this.hours = [
            { label: '09:00', value: 9 },
            { label: '10:00', value: 10 },
            { label: '11:00', value: 11 },
            { label: '12:00', value: 12 },
            { label: '13:00', value: 13 },
            { label: '14:00', value: 14 },
            { label: '15:00', value: 15 },
            { label: '16:00', value: 16 },
            { label: '17:00', value: 17 },
            { label: '18:00', value: 18 }
            // { label: '19:00', value: 19 },
            // { label: '20:00', value: 20 }
        ];
        this.taskTypes = ["Maintenance", "Quality", "Layout", "Documentation", "Discoms", "Others", "Rms Scan", "Cheque Collection", "Site Ceremony", "Subsidy", "Flex Upload", "Resolve EB Issue", "NM Apply", "Complete NM", "Assign V2", "Structure Delivery", "Upload MA and NM agreements", "Upload DCR", "Upload WCR", "Upload Annexure and Meter Testing Documents", "Need GeoTag Photo", "Align Vendor Payment"];
        this.priorityTypes = ["High", "Medium", "Low"];
    }

    componentDidMount() {
        if (this.props.user) {
            if (this.props.user.level >= 1600) {
                this.updateSelectedStateLocalStorage();
                this.props.fetchPeTask({ status: '0' });
                // this.props.fetchQuoteId();
                this.props.fetchPeMapping();
                this.props.fetchLoggedInUserName(this.props.user.phoneNumber);
                this.props.fetchmainview();
            }
        }
    }

    updateSelectedStateLocalStorage = () => {
        try {
            let selectViewStr = localStorage.getItem("selectedPeTaskStates");
            if (!selectViewStr) return;
            selectViewStr = JSON.parse(selectViewStr);
            this.setState({ selectView: selectViewStr });
            return;
        }
        catch (error) {
            console.log("updateSelectedStateLocalStorage", error);
            return;
        }
    }


    componentWillReceiveProps(props) {
        let { peData, quoteIdList, peMapping, employeeList, loading, fetchQuoteIdError, stateCityMap, stateSubsidyMap, cityDiscomMap, taskComments, completed, data } = props;
        let { appliedFilters, selectView = {} } = this.state;
        let { state, employee } = appliedFilters;
        let viewData = (peData || []).filter(task => {
            if ((!state || state == task.state) && (!employee || employee == task.employeeId) && (selectView['ALL'] || selectView[task.state.toUpperCase()])) {
                return true;
            }
            else {
                return false;
            }
        })
        let cityList = Object.values(stateCityMap || {}).reduce((cityList, current) => [...cityList, ...current], []);
        this.setState({
            viewData,
            allData: peData,
            quoteList: quoteIdList || [],
            peMapping: peMapping || {},
            employeeList: employeeList || {},
            loading,
            editButton: peMapping && Object.keys(peMapping).length ? false : true,
            fetchQuoteIdError,
            stateCityMap,
            stateSubsidyMap,
            cityDiscomMap,
            cityList,
            taskComments
        })
        if (completed && Object.values(data).length) {
            console.log(completed, Object.values(data).length);
            this.updateQuoteStageMap(data);
        }
        if (employeeList && Object.keys(employeeList).length) {
            let showColumns = [...this.state.showColumns];
            let columns = showColumns.map(val => {
                let column = { ...val };
                if (column.accessor == 'employeeId') {
                    column.Cell = row => <div>{employeeList[row.value]}</div>
                }
                return column;
            })
            this.setState({
                showColumns: columns
            })
        }
    }

    updateQuoteStageMap = (dealsData = {}) => {
        const quoteStageMap = {};
        Object.values(dealsData).map(row => {
            let { quoteid = '', stageVariables = '' } = row;
            try {
                stageVariables = JSON.parse(stageVariables);
                let { stage1 = '', stage2 = '' } = stageVariables;
                if (stage1 && stage2) {
                    quoteStageMap[quoteid] = {
                        stage1: stage1,
                        stage2: stage2
                    }
                }
            }
            catch (e) { }
        })
        this.setState({ quoteToStageMap: quoteStageMap });
    }

    openModal = () => {
        let defaultDate = moment().add(1, 'days').format('YYYY-MM-DD');
        this.setState({
            openCreateModal: true,
            newTask: {
                date: defaultDate,
                team: ''
            }
        })
    }

    onCloseCreateModal = () => {
        this.setState({
            openCreateModal: false
        })
    }

    onCloseUpdateModal = () => {
        this.setState({
            openUpdateModal: false
        })
    }

    handleSelectChange = (e, name) => {
        if (name == 'quoteId') {
            this.setState({
                newTask: {
                    ...this.state.newTask,
                    [name]: e.value,
                    state: e.state,
                    size_del: e.size_del,
                    city: e.city
                }
            })
        }
        else if (name == 'type') {
            let typeList = (e || []).map(row => row.value);
            let taskType = [];
            if ((typeList.includes('Discoms') || typeList.includes('Subsidy')) && typeList.length > 1) {
                taskType = [typeList[typeList.length - 1]];
            }
            else {
                taskType = typeList;
            }
            this.setState({
                newTask: {
                    ...this.state.newTask,
                    [name]: taskType.join(', ')
                }
            })
        }
        else {
            this.setState({
                newTask: {
                    ...this.state.newTask,
                    [name]: e.value
                }
            })
        }
    }

    handleSelectChangeFilters = (e, name) => {
        this.setState({
            filters: {
                ...this.state.filters,
                [name]: e.value
            }
        })
    }

    handleSelectChangeUpdate = (e, name) => {
        if (name == 'type') {
            let typeList = (e || []).map(row => row.value);
            let taskType = [];
            if ((typeList.includes('Discoms') || typeList.includes('Subsidy')) && typeList.length > 1) {
                taskType = [typeList[typeList.length - 1]];
            }
            else {
                taskType = typeList;
            }
            this.setState({
                updateTask: {
                    ...this.state.updateTask,
                    [name]: taskType.join(', ')
                }
            });
            return;
        }
        this.setState({
            updateTask: {
                ...this.state.updateTask,
                [name]: e.value
            }
        })
    }

    handleInputChange = (e) => {
        let { name, value } = e.target;
        this.setState({
            newTask: {
                ...this.state.newTask,
                [name]: value
            }
        })
    }

    handleInputChangeFilters = (e) => {
        let { name, value } = e.target;
        this.setState({
            filters: {
                ...this.state.filters,
                [name]: value
            }
        })
    }

    handleInputChangeUpdate = (e) => {
        let { name, value } = e.target;
        this.setState({
            updateTask: {
                ...this.state.updateTask,
                [name]: value
            }
        })
    }


    createTaskSubmit = () => {
        let { newTask, allData } = this.state;
        this.props.createNewTask(newTask, allData, this.props.user.phoneNumber);
        // this.setState({
        //     openCreateModal:false
        // })
    }

    updateTaskSubmit = () => {
        let { updateTask, allData } = this.state;
        this.props.updateTask(updateTask, allData, this.props.user.phoneNumber);
        // this.setState({
        //     openUpdateModal:false
        // })
    }

    applyFilters = () => {
        console.log("apply");
        let { filters } = this.state;
        this.setState({
            loading: true,
            appliedFilters: filters
        })
        this.props.fetchPeTask(filters);
    }

    editTask = (taskId) => {
        let { allData } = this.state;
        let taskData = allData.find(task => task.taskId == taskId);
        let taskDefaultData = {
            date: moment(taskData.date, 'YYYYMMDD').format('YYYY-MM-DD'),
            quoteId: taskData.quoteId,
            state: taskData.state,
            type: taskData.type,
            employee: taskData.employeeId,
            pmComment: taskData.pmComment,
            comment: taskData.comment,
            id: taskData.taskId,
            priority: taskData.priority,
            status: taskData.status,
            statusVal: taskData.statusVal,
            city: taskData.city,
            team: taskData.team
        };
        this.setState({
            openUpdateModal: true,
            updateTask: taskDefaultData
        })
    }

    handleOnViewChange = (value) => {
        let { selectView = {} } = this.state;
        value = value.toUpperCase();
        if (value == "ALL") {
            selectView = { "ALL": 1 };
        }
        else {
            if (selectView[value]) {
                delete selectView[value];
                if (Object.keys(selectView).length == 0) {
                    selectView["ALL"] = 1;
                }
            }
            else {
                delete selectView["ALL"];
                selectView[value] = 1;
            }
        }
        console.log(selectView)
        localStorage.setItem("selectedPeTaskStates", JSON.stringify(selectView));
        this.setState({
            selectView: selectView
        }, () => {
            this.updateDataViewChange();
        })
    }

    updateDataViewChange = () => {
        let { allData = [], selectView = {} } = this.state;
        let viewData = (allData || []).filter(task => {
            if (selectView['ALL'] || selectView[task.state.toUpperCase()]) {
                return true;
            }
            else {
                return false;
            }
        })
        this.setState({
            viewData
        })
    }

    deleteTask = (taskId) => {
        let { allData } = this.state;
        this.props.deleteTask(taskId, allData, this.props.user.phoneNumber);
    }

    inputQuoteIdChange = (e = "") => {
        if (!e) {
            return;
        }
        this.setState({
            quoteList: [],
            fetchQuoteIdError: false
        })
        let { searchBy } = this.state;
        this.props.searchSites(e, searchBy.value);
    }

    onCloseAutoAssignModal = () => {
        console.log("close");
        this.props.resetAutoAssign();
        // this.applyFilters();
        this.setState({
            openAutoAssignModal: false
        })
    }

    onClickAutoAssign = () => {
        this.props.resetAutoAssign();
        this.setState({
            openAutoAssignModal: true
        })
    }

    handleSelectChangeAutoAssign = (e, name) => {
        this.setState({
            autoAssignData: {
                ...this.state.autoAssignData,
                [name]: e.value
            }
        })
    }

    handleInputChangeAutoAssign = (e) => {
        let { name, value } = e.target;
        this.setState({
            autoAssignData: {
                ...this.state.autoAssignData,
                [name]: value
            }
        })
    }

    autoAssignTaskSubmit = () => {
        let { autoAssignData = {} } = this.state;
        this.props.autoAssignTasks(autoAssignData);
        console.log("data", autoAssignData);
    }

    onCloseCommentsModal = () => {
        this.setState({ openCommentsModal: false })
    }

    onOpenCommentsModal = (taskId) => {
        console.log("taskId", taskId);
        this.setState({ openCommentsModal: true, newCommentText: '', commentForTaskId: taskId, taskComments: [] })
        this.props.fetchTaskComments(taskId);
    }

    handleNewCommentChange = (e) => {
        let { value } = e.target;
        this.setState({ newCommentText: value });
    }

    handleNewCommentSubmit = () => {
        console.log("handleNewCommentSubmit", this.state.newCommentText);
        let { newCommentText = '', commentForTaskId = '' } = this.state;
        this.props.addNewComment({
            taskId: commentForTaskId,
            comment: newCommentText,
            commentedBy: this.props.user.phoneNumber,
            commentedByName: this.props.username
        })
        this.setState({ openCommentsModal: false })
    }

    CommentList = ({ comments = [] }) => {
        comments = comments.sort((a, b) => a.commentedOn - b.commentedOn);
        return (
            <div>
                {comments.map(commentObj => {
                    return <p><b>{commentObj.commentedByName}</b>&nbsp;-&nbsp;<b>{moment(+commentObj.commentedOn).format("DD MMM YYYY HH:mm:ss")}</b>&nbsp;-&nbsp;{commentObj.comment}</p>
                })}
            </div>
        );
    };

    onMarkingTaskComplete = (taskId) => {
        console.log("onMarkingTaskComplete", taskId);
        let { allData } = this.state;
        this.props.markTaskComplete(taskId, allData, this.props.user.phoneNumber);
    }

    render() {
        if (this.props.user === null) {
            return <Redirect to={"/login?redirect_uri=petasksv2"} />;
        }
        if (this.props.user && this.props.user.level < 1600) {
            return (
                <div>
                    <Restrict />
                </div>
            )
        }
        const modalStyles = {
            modal: {
                width: '80%',
                maxWidth: '80%',
                padding: '40px'
            }
        }
        const commentModalStyles = {
            modal: {
                width: '60%',
                maxWidth: '60%',
                padding: '40px'
            }
        }

        console.log("this.props.user", this.props.user);

        let { handleSelectChange, hours, taskTypes, priorityTypes, createTaskSubmit, handleInputChange, handleInputChangeFilters, handleSelectChangeFilters, applyFilters, onCloseCreateModal, onCloseUpdateModal, editTask, handleInputChangeUpdate, handleSelectChangeUpdate, updateTaskSubmit, handleOnViewChange, deleteTask, onCloseAutoAssignModal, onClickAutoAssign, handleSelectChangeAutoAssign, handleInputChangeAutoAssign, autoAssignTaskSubmit, onCloseCommentsModal, handleNewCommentChange, handleNewCommentSubmit, CommentList } = this;
        let { newTask, quoteList, peMapping, employeeList, filters, updateTask, openCreateModal, openUpdateModal, editButton, selectView = {}, searchBy, stateCityMap, stateSubsidyMap, cityDiscomMap, openAutoAssignModal, cityList, autoAssignData, openCommentsModal, newCommentText, taskComments = [], quoteToStageMap = {} } = this.state;
        let { autoAssignStatus = {}, pmMapping = [] } = this.props;
        let employeeListOptionsCreate = [];
        if (newTask.team == "PE" && newTask.state) {
            employeeListOptionsCreate = peMapping[newTask.state] || [];
        }
        else {
            employeeListOptionsCreate = pmMapping || {};
        }
        let employeeListOptionsUpdate = [];
        if (updateTask.team == "PE" && updateTask.state) {
            employeeListOptionsUpdate = peMapping[updateTask.state] || [];
        }
        else {
            employeeListOptionsUpdate = pmMapping || {};
        }
        return (

            <div style={{ "marginTop": 50 }} className="container-fluid">
                <div className="formButtons" style={{ float: 'left' }}>
                    <button className={`btn btn-primary paymentViewButton btn-color ${selectView["ALL"] ? "select" : ""}`} name={"ALL"} onClick={(e) => handleOnViewChange("ALL")} value={"ALL"}>{"ALL"}</button>
                    {
                        Array.from(new Set([...preferredStates, ...Object.keys(peMapping ? peMapping : {})])).map(state => {
                            return (
                                <button className={`btn btn-primary paymentViewButton btn-color ${selectView[state.toUpperCase()] ? "select" : ""}`} name={state} onClick={(e) => handleOnViewChange(state)} value={state}>{state}</button>
                            )
                        })
                    }
                </div>
                <div style={{ float: 'right' }}>
                    <Link to={"/petaskcenters"} className="btn btn-info" onClick={(event) => { event.preventDefault(); window.open(window.location.origin + "/petaskcenters/"); }}>Subsidy/Discom Centers <i className="fa fa-external-link-alt" aria-hidden="true"></i></Link>
                </div>
                <div style={{ clear: 'both' }}></div>
                <button className="btn btn-success" style={{ marginTop: '1%' }} onClick={() => this.openModal()}>Create Task</button>
                <div className="row filters">
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <div className="form-group">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Start Date</span>
                                </div>
                                <input className="form-control customInput" type="date" name={"startDate"} placeholder={"Start Date"} onChange={(e) => handleInputChangeFilters(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <div className="form-group">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">End Date</span>
                                </div>
                                <input className="form-control customInput" type="date" name={"endDate"} placeholder={"End Date"} onChange={(e) => handleInputChangeFilters(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <Select
                            isSearchable
                            placeholder={"Select State"}
                            name={"state"}
                            options={[{ label: 'Select', value: '' }, ...Object.keys(peMapping ? peMapping : {}).map(val => { return ({ label: val, value: val }) })]}
                            onChange={(e) => handleSelectChangeFilters(e, "state")}
                        />
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <Select
                            isSearchable
                            placeholder={"Select Employee"}
                            name={"employee"}
                            options={[{ label: 'Select', value: '' }, ...(filters.state ? peMapping[filters.state].map(val => { return ({ label: employeeList[val], value: val }) }) : [])]}
                            onChange={(e) => handleSelectChangeFilters(e, "employee")}
                        />
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <Select
                            isSearchable
                            placeholder={"Select status"}
                            name={"status"}
                            options={[{ label: 'All', value: '' }, ...statusOptions]}
                            onChange={(e) => handleSelectChangeFilters(e, "status")}
                            defaultValue={{ label: 'Pending', value: '0' }}
                        />
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <Select
                            isSearchable
                            placeholder={"Select Team"}
                            name={"team"}
                            options={[{ label: 'All', value: '' }, ...teamOptions]}
                            onChange={(e) => handleSelectChangeFilters(e, "team")}
                        />
                    </div>
                    <div className="col" style={{ width: '100%', paddingTop: '1%' }}>
                        <button className="btn btn-success" onClick={() => applyFilters()} style={{ float: 'left' }}>Apply Filter</button>
                        {/* <button className="btn btn-outline-primary" onClick={() => onClickAutoAssign()} style={{ float: 'right' }}>Auto Assign Tasks</button> */}
                    </div>
                </div>
                <Modal styles={modalStyles} open={openCreateModal} onClose={() => onCloseCreateModal()}>
                    <div style={{ textAlign: 'center', fontSize: '22px' }}>Create Task</div>
                    <div className="row">
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="row">
                                <Select
                                    placeholder={"Search"}
                                    name={"searchBy"}
                                    options={[{ label: "Quote Id", value: "quoteId" }, { label: "Name", value: "name" }]}
                                    onChange={(e) => this.setState({ searchBy: e })}
                                    className={"col-md-4"}
                                    value={searchBy}
                                />
                                <Select
                                    isSearchable
                                    placeholder={"Select Quote Id"}
                                    name={"quoteId"}
                                    options={quoteList.map(val => { return ({ label: `${val.quoteId} ${val.name}`, value: val.quoteId, state: val.state, size_del: val.size_del, city: val.city || "" }) })}
                                    onChange={(e) => handleSelectChange(e, "quoteId")}
                                    onInputChange={debounce((e) => this.inputQuoteIdChange(e), 3000)}
                                    noOptionsMessage={() => this.state.fetchQuoteIdError ? "No results found" : "Loading..."}
                                    className={"col-md-8"}
                                />
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select State"}
                                name={"state"}
                                value={Object.keys(peMapping).map(val => { return ({ label: val, value: val }) }).find(val => val.value == newTask.state)}
                                options={Object.keys(peMapping).map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChange(e, "state")}
                            />
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Team"}
                                name={"team"}
                                value={newTask.team ? { label: newTask.team, value: newTask.team } : ""}
                                options={teamOptions}
                                onChange={(e) => handleSelectChange(e, "team")}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Employee"}
                                name={"employee"}
                                options={(employeeListOptionsCreate || []).map(val => { return ({ label: employeeList[val], value: val }) })}
                                onChange={(e) => handleSelectChange(e, "employee")}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select City"}
                                name={"city"}
                                options={newTask.state ? (stateCityMap[newTask.state] || []).map(val => { return ({ label: val, value: val }) }) : []}
                                onChange={(e) => handleSelectChange(e, "city")}
                                value={newTask.city ? { label: newTask.city, value: newTask.city } : ""}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">Date</span>
                                    </div>
                                    <input className="form-control customInput" type="date" name={"date"} placeholder={"date"} value={newTask.date} onChange={(e) => handleInputChange(e)} />
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Start Time"}
                                name={"startTime"}
                                options={hours}
                                onChange={(e) => handleSelectChange(e, "startTime")}
                            />
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isMulti
                                isSearchable
                                placeholder={"Select Task Type"}
                                name={"type"}
                                options={taskTypes.map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChange(e, "type")}
                                value={newTask.type ? newTask.type.split(', ').map(val => { return ({ label: val, value: val }) }) : []}
                            />
                        </div>
                        {
                            newTask.type == "Subsidy" ? <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                                <Select
                                    isSearchable
                                    placeholder={"Select Center"}
                                    name={"centerKey"}
                                    options={newTask.state ? (stateSubsidyMap[newTask.state] || []) : []}
                                    onChange={(e) => handleSelectChange(e, "centerKey")}
                                />
                            </div> : ""
                        }
                        {
                            newTask.type == "Discoms" ? <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                                <Select
                                    isSearchable
                                    placeholder={"Select Center"}
                                    name={"centerKey"}
                                    options={newTask.city ? (cityDiscomMap[newTask.city] || []) : []}
                                    onChange={(e) => handleSelectChange(e, "centerKey")}
                                />
                            </div> : ""
                        }
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">PM Comment</span>
                                    </div>
                                    <input className="form-control customInput" type="comment" name={"pmComment"} placeholder={"PM Comment"} onChange={(e) => handleInputChange(e)} />
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">Comment</span>
                                    </div>
                                    <input className="form-control customInput" type="comment" name={"comment"} placeholder={"Comment"} onChange={(e) => handleInputChange(e)} />
                                </div>
                            </div>
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Priority"}
                                name={"priority"}
                                options={priorityTypes.map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChange(e, "priority")}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <button className="btn btn-success" onClick={() => createTaskSubmit()}>Create</button>
                        </div>
                    </div>
                </Modal>
                <Modal styles={modalStyles} open={openUpdateModal} onClose={() => onCloseUpdateModal()}>
                    <div style={{ textAlign: 'center', fontSize: '22px' }}>Update Task</div>
                    <div className="row">
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="row">
                                <Select
                                    placeholder={"Search"}
                                    name={"searchBy"}
                                    options={[{ label: "Quote Id", value: "quoteId" }, { label: "Name", value: "name" }]}
                                    onChange={(e) => this.setState({ searchBy: e })}
                                    className={"col-md-4"}
                                    value={searchBy}
                                />
                                <Select
                                    isSearchable
                                    placeholder={"Select Quote Id"}
                                    name={"quoteId"}
                                    options={quoteList.map(val => { return ({ label: `${val.quoteId} ${val.name}`, value: val.quoteId, state: val.state, size_del: val.size_del }) })}
                                    onChange={(e) => handleSelectChangeUpdate(e, "quoteId")}
                                    // defaultValue={quoteList.map(val => { return ({ label: `${val.quoteId} ${val.name}`, value: val.quoteId, state: val.state }) }).find(val=>val.value==updateTask.quoteId)}
                                    defaultValue={[{ label: updateTask.quoteId, value: updateTask.quoteId }]}
                                    onInputChange={debounce((e) => this.inputQuoteIdChange(e), 3000)}
                                    noOptionsMessage={() => this.state.fetchQuoteIdError ? "No results found" : "Loading..."}
                                    className={"col-md-8"}
                                />
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select State"}
                                name={"state"}
                                options={Object.keys(peMapping).map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChangeUpdate(e, "state")}
                                defaultValue={Object.keys(peMapping).map(val => { return ({ label: val, value: val }) }).find(val => val.value == updateTask.state)}
                            />
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Team"}
                                name={"team"}
                                options={teamOptions}
                                onChange={(e) => handleSelectChangeUpdate(e, "team")}
                                defaultValue={updateTask.team ? { label: updateTask.team, value: updateTask.team } : ""}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Employee"}
                                name={"employee"}
                                options={employeeListOptionsUpdate.map(val => { return ({ label: employeeList[val], value: val }) })}
                                onChange={(e) => handleSelectChangeUpdate(e, "employee")}
                                defaultValue={(employeeListOptionsUpdate || []).map(val => { return ({ label: employeeList[val], value: val }) }).find(val => val.value == updateTask.employee)}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select City"}
                                name={"city"}
                                options={updateTask.state && Object.keys(stateCityMap).length ? stateCityMap[updateTask.state].map(val => { return ({ label: val, value: val }) }) : []}
                                onChange={(e) => handleSelectChangeUpdate(e, "city")}
                                defaultValue={(updateTask.state && Object.keys(stateCityMap).length ? stateCityMap[updateTask.state].map(val => { return ({ label: val, value: val }) }) : []).find(val => val.value == updateTask.city)}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">Date</span>
                                    </div>
                                    <input className="form-control customInput" type="date" name={'date'} placeholder={"date"} defaultValue={updateTask.date} onChange={(e) => handleInputChangeUpdate(e)} />
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Start Time"}
                                name={"startTime"}
                                options={hours}
                                onChange={(e) => handleSelectChangeUpdate(e, "startTime")}
                                defaultValue={hours.find(val => val.value == updateTask.startTime)}
                            />
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isMulti
                                isSearchable
                                placeholder={"Select Task Type"}
                                name={"type"}
                                options={taskTypes.map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChangeUpdate(e, "type")}
                                // defaultValue={taskTypes.map(val => { return ({ label: val, value: val }) }).find(val => val.value==updateTask.type)}
                                value={updateTask.type ? updateTask.type.split(', ').map(val => { return ({ label: val, value: val }) }) : []}
                            />
                        </div>
                        {
                            updateTask.type == "Subsidy" ? <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                                <Select
                                    isSearchable
                                    placeholder={"Select Center"}
                                    name={"centerKey"}
                                    options={updateTask.state ? (stateSubsidyMap[updateTask.state] || []) : []}
                                    onChange={(e) => handleSelectChange(e, "centerKey")}
                                    defaultValue={(updateTask.state && Object.keys(stateSubsidyMap).length ? (stateSubsidyMap[updateTask.state] || []) : []).find(val => val.value == updateTask.centerKey)}
                                />
                            </div> : ""
                        }
                        {
                            updateTask.type == "Discoms" ? <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                                <Select
                                    isSearchable
                                    placeholder={"Select Center"}
                                    name={"centerKey"}
                                    options={updateTask.city ? (cityDiscomMap[updateTask.city] || []) : []}
                                    onChange={(e) => handleSelectChange(e, "centerKey")}
                                    defaultValue={(updateTask.city && Object.keys(cityDiscomMap).length ? (cityDiscomMap[updateTask.city] || []) : []).find(val => val.value == updateTask.centerKey)}
                                />
                            </div> : ""
                        }
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">PM Comment</span>
                                    </div>
                                    <input className="form-control customInput" type="comment" name={"pmComment"} defaultValue={updateTask.pmComment} placeholder={" PM Comment"} onChange={(e) => handleInputChangeUpdate(e)} />
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <div className="form-group">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">Comment</span>
                                    </div>
                                    <input className="form-control customInput" type="comment" name={"comment"} defaultValue={updateTask.comment} placeholder={"Comment"} onChange={(e) => handleInputChangeUpdate(e)} />
                                </div>
                            </div>
                        </div> */}
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <Select
                                isSearchable
                                placeholder={"Select Priority"}
                                name={"priority"}
                                options={priorityTypes.map(val => { return ({ label: val, value: val }) })}
                                onChange={(e) => handleSelectChangeUpdate(e, "priority")}
                                defaultValue={priorityTypes.map(val => { return ({ label: val, value: val }) }).find(val => val.value == updateTask.priority)}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                            <button className="btn btn-success" onClick={() => updateTaskSubmit()}>Update Task</button>
                        </div>
                    </div>
                </Modal>
                <Modal styles={modalStyles} open={openAutoAssignModal} onClose={() => onCloseAutoAssignModal()}>
                    <div style={{ textAlign: 'center', fontSize: '22px' }}>Auto assign tasks</div>
                    {
                        !autoAssignStatus.value ? <div className="row">
                            <div className="col-12 col-md-4" style={{ paddingTop: '2%' }}>
                                <Select
                                    isSearchable
                                    placeholder={"Select City"}
                                    name={"city"}
                                    value={cityList.map(val => { return ({ label: val, value: val }) }).find(val => val.value == autoAssignData.city)}
                                    options={cityList.map(val => { return ({ label: val, value: val }) })}
                                    onChange={(e) => handleSelectChangeAutoAssign(e, "city")}
                                />
                            </div>
                            <div className="col-12 col-md-4" style={{ width: '100%', paddingTop: '2%' }}>
                                <div className="form-group">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">Date</span>
                                        </div>
                                        <input className="form-control customInput" type="date" name={"date"} placeholder={"date"} value={autoAssignData.date} onChange={(e) => handleInputChangeAutoAssign(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4" style={{ paddingTop: '2%' }}>
                                <button className="btn btn-light btn-lg" onClick={() => autoAssignTaskSubmit()}>Assign</button>
                            </div>
                        </div> : <div style={{ textAlign: 'center', paddingTop: '2%', fontSize: '18px' }}>{autoAssignStatus.text}</div>
                    }
                </Modal>
                <Modal styles={commentModalStyles} open={openCommentsModal} onClose={() => onCloseCommentsModal()}>
                    <div style={{ textAlign: 'center', fontSize: '22px' }}>Comments</div>
                    {
                        Object.values(taskComments).length ? <CommentList comments={Object.values(taskComments)} /> : <p>No comments found for this task</p>
                    }
                    <div className="newCommentDiv" style={{ width: '50%', margin: '0 auto' }}>
                        <div className="form-group">
                            <div className="input-group mb-3">
                                <textarea className="form-control customInput" value={newCommentText} onChange={(e) => handleNewCommentChange(e)} placeholder='enter comment here' />
                            </div>
                        </div>
                        <div style={{ right: "0px", textAlign: "right" }}>
                            <button className="btn btn-success btn-lg" onClick={() => handleNewCommentSubmit()}>Submit</button>
                        </div>
                    </div>
                </Modal>
                <ReactTable
                    filterable={true}
                    showPagination={true}
                    sortable={true}
                    data={this.state.viewData}
                    ref={this.reactTable}
                    columns={[...this.state.showColumns.slice(0, 2), {
                        Header: 'Stage 1',
                        accessor: 'stage1',
                        Cell: row => {
                            return (quoteToStageMap[row.original.quoteId] || {}).stage1 || ""
                        }
                    },
                    {
                        Header: 'Stage 2',
                        accessor: 'stage2',
                        Cell: row => {
                            return (quoteToStageMap[row.original.quoteId] || {}).stage2 || ""
                        }
                    },
                    ...this.state.showColumns.slice(2)
                        , {
                        Header: 'Mark Complete',
                        Cell: row => {
                            return row.original.status != "1" && this.props.user.level >= 1900 ? <div><button className="btn btn-info" onClick={() => this.onMarkingTaskComplete(row.original.taskId)} disabled={editButton}>Mark Complete</button></div> : ""
                        }
                    }
                        , {
                        Header: 'Comments',
                        Cell: row => {
                            return <div><button className="btn btn-info" onClick={() => this.onOpenCommentsModal(row.original.taskId)} disabled={editButton}>Comments</button></div>
                        }
                    }, {
                        Header: 'Edit',
                        Cell: row => {
                            return <div><button className="btn btn-success" onClick={() => editTask(row.original.taskId)} disabled={editButton}>Edit</button> <button className="btn btn-danger" onClick={() => deleteTask(row.original.taskId)} disabled={editButton}>Delete</button></div>
                        }
                    }]}
                    defaultSorted={[{ id: "date", desc: true }]}
                    style={{ height: "90vh", textAlign: 'center' }}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]).toLowerCase().indexOf(filter.value.toLowerCase()) > -1}
                    loading={this.state.loading}
                />
            </div>
        );


    }
}

const selectCustom = (options, name, placeholder, handleMultiSelectChange, defaultValue) => {
    const changeHandle = (value) => { handleMultiSelectChange(value, name) }
    return (
        <div className="drop_down1">
            <Select
                isMulti
                isSearchable
                onChange={(e) => { changeHandle(e) }}
                placeholder={placeholder}
                name={name}
                options={options}
                defaultValue={defaultValue}
            />
        </div>
    )
}


function mapStateToProps(state) {
    let { tableData, quoteIdList, peMapping, employeeList, loading, fetchQuoteIdError = false, stateCityMap = {}, stateSubsidyMap = {}, cityDiscomMap = {}, autoAssignStatus = {}, username = '', taskComments = [], pmMapping = [] } = state.pedata || {};
    let { data, completed } = state.dealsdata || {};
    console.log("username", username);
    return {
        user: state.user,
        peData: tableData,
        quoteIdList,
        peMapping,
        employeeList,
        loading,
        fetchQuoteIdError,
        stateCityMap,
        stateSubsidyMap,
        cityDiscomMap,
        autoAssignStatus,
        username,
        taskComments: taskComments,
        data: data,
        completed: completed,
        pmMapping: pmMapping
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchPeTask, fetchQuoteId, fetchPeMapping, createNewTask, updateTask, deleteTask, searchSites, resetAutoAssign, autoAssignTasks, fetchLoggedInUserName, addNewComment, fetchTaskComments, fetchmainview, markTaskComplete }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PeTaskV2);